import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { WorkNote, CreateWorkNoteDto } from '../models/work-note.model';

@Injectable({
  providedIn: 'root'
})
export class WorkNoteService {
  private apiUrl = `${environment.apiUrl}/WorkNote`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<WorkNote[]> {
    return this.http.get<WorkNote[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<WorkNote> {
    return this.http.get<WorkNote>(`${this.apiUrl}/${id}`);
  }

  addNote(note: CreateWorkNoteDto): Observable<WorkNote> {
    return this.http.post<WorkNote>(this.apiUrl, note);
  }

  updateNote(id: string, note: WorkNote): Observable<WorkNote> {
    return this.http.put<WorkNote>(`${this.apiUrl}/${id}`, note);
  }

  deleteNote(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}


